export const measureTextWidth = (text: string, font = 'bold 10px sans-serif') => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) return 0;

  ctx.font = font;

  return ctx.measureText(text).width;
}
